import { Event, Parameter } from '../types'

export const mapOptions = {
    fullscreenControl: false,
    noClear: true,
    streetViewControl: true,
    mapTypeControl: false,
    mapTypeId: 'roadmap',
    heading: 90,
    tilt: 45,
    minZoom: 4,
    maxZoom: 23,
    controlSize: 23
}

export const fitBounds = (points: google.maps.LatLng[], map: google.maps.Map) => {
    if (map && points.length > 0) {
        const bounds = new google.maps.LatLngBounds()
        points.forEach(latLng => {
            bounds.extend(latLng)
        })

        map.fitBounds(bounds)
    }
}

// const fitPolygonsBounds = (map, polygons: google.maps.Polygon[]) => {
//   var bounds = new google.maps.LatLngBounds();

//   for (var i = 0; i < polygons.length; i++) {
//     var polygon = polygons[i];
//     var paths = polygon.getPath().getArray();

//     for (var j = 0; j < paths.length; j++) {
//       bounds.extend(paths[j]);
//     }
//   }

//   map.fitBounds(bounds);
// }

export const getBoundsPolygons = (polygons: google.maps.Polygon[]) => {
    var bounds = new google.maps.LatLngBounds()
    let points = []

    for (let n = 0; n < polygons.length; n++) if (polygons[n]) points.push(...polygons[n].getPath().getArray())

    for (var n = 0; n < points.length; n++) {
        bounds.extend(points[n])
    }

    return bounds
}

export const createPolygons = (
    map,
    events: Event[],
    onClickPolygon?: (event: Event, latLng: google.maps.LatLng) => void,
    cachePolygonsRef?: { event: Event; polygon: google.maps.Polygon }[]
): { event: Event; polygon: google.maps.Polygon }[] => {

    if(!cachePolygonsRef) return 

    let list: { event: Event; polygon: google.maps.Polygon }[] = cachePolygonsRef 

    if (map) {
        for (let i = 0; i < events.length; i++) {
            if (events[i] !== undefined) {
                const { latMin, lngMin, latMax, lngMax, color } = events[i]

                const polygon = new google.maps.Polygon({
                    path: [
                        { lat: latMin, lng: lngMin },
                        { lat: latMin, lng: lngMax },
                        { lat: latMax, lng: lngMax },
                        { lat: latMax, lng: lngMin }
                    ],
                    strokeColor: color,
                    strokeOpacity: 1.0,
                    strokeWeight: 0.5,
                    fillColor: color,
                    fillOpacity: 0.4,
                    geodesic: true,
                    clickable: true
                })

                polygon.setMap(map)

                if (onClickPolygon) {
                    polygon.addListener('click', param => {
                        onClickPolygon(events[i], param.latLng)
                    })
                }
                list.push({ event: events[i], polygon })
            }
        }
    }

    return list
}

export const updatePolygons = (
    parameterActiveID: number,
    dataEventsPolygon: { event: Event; polygon: google.maps.Polygon }[]
): void => {
    for (let i = 0; i < dataEventsPolygon.length; i++) {
        if (dataEventsPolygon[i] !== undefined) {
            const { latMin, lngMin, latMax, lngMax, data } = dataEventsPolygon[i].event
            
            const dataAux = data?.find(ele => ele.parameterID === parameterActiveID)
            if (dataEventsPolygon[i].polygon.get('strokeColor') !== dataAux?.color) {
                const options = {
                    path: [
                        { lat: latMin, lng: lngMin },
                        { lat: latMin, lng: lngMax },
                        { lat: latMax, lng: lngMax },
                        { lat: latMax, lng: lngMin }
                    ],
                    strokeColor: dataAux?.color,
                    strokeOpacity: 1.0,
                    strokeWeight: 0.5,
                    fillColor: dataAux?.color,
                    fillOpacity: 0.4,
                    geodesic: true,
                    clickable: true
                }

                dataEventsPolygon[i].polygon.setOptions(options)
            }
        }
    }
}

export const clearPolygons = (
    dataEventsPolygon: { event: Event; polygon: google.maps.Polygon }[]
): void => {
    if(!dataEventsPolygon) return
    for (let i = 0; i < dataEventsPolygon.length; i++) {
        if (dataEventsPolygon[i] !== undefined) {
            dataEventsPolygon[i].polygon.setMap(null)
        }
    }
    
    dataEventsPolygon.length = 0
}
